import { render } from "./FooterCircle.vue?vue&type=template&id=e015ce4a"
import script from "./FooterCircle.vue?vue&type=script&lang=js"
export * from "./FooterCircle.vue?vue&type=script&lang=js"

import "./FooterCircle.vue?vue&type=style&index=0&id=e015ce4a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__